import { getParam } from './tools'
import Cookies from 'js-cookie';
import {AD_ID_COOKIES_KEY} from './constant'

// 图片地址
export const IMG_BASE_URL = 'https://static.novelfreedom.com/';
export const LOCAL_IMG_URL = IMG_BASE_URL + 'paynovel/h5-pay-asia/';
// https://static.novelfreedom.com/paynovel/h5-pay-asia/


// 获取版本号
export const getVersion = () => {
    return '1.1.0'
}

// 获取fb pixel id
export const getFbPixelId = () => {
    return APP_CONFIG[getAppID()]?.fbPixleId || APP_CONFIG['default'].fbPixleId
}

export const getAppID = ()=>{
    if(process.env.NODE_ENV === 'dev'){
        return 'durianovel'
    }
    let host = location.host && location.host.split('.'); 
    return host.length < 2 ? "" : host[host.length -2];
}


export const setCookieFbc = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
        const fbc = `fb.1.${Date.now()}.${fbclid}`;
        document.cookie = `_fbc=${encodeURIComponent(fbc)}; max-age=7776000; path=/; SameSite=Lax`;
    }
}

export const setCookieAdId = () => {
    const adId = getParam('af_ad_id');
    if (adId) {
        Cookies.set(AD_ID_COOKIES_KEY, adId, { expires: 365, path: '/' });
    }
}

export const APP_CONFIG = {
    wonderfulnovel: {
        fbPixleId: '571660755779128',
    },
    lucknovel: {
        fbPixleId: '571660755779128',
    },
    tintnovel: {
        fbPixleId: '1153836469730919',
    },
    slownovel: {
        fbPixleId: '1153836469730919',
    },
    colornovel:{
        fbPixleId: '1169944321513777',
    },
    lemonnovel: {
        fbPixleId: '657585096792474',
    },
    novellettes: {
        fbPixleId: '1081737203961773',
        moneySymbol: '₱',
    },
    lovernovel: {
        fbPixleId: '2872547796247341',
    },
    melonnovel: {
        fbPixleId: '638266961935203',
    },
    pearnovel:{
        fbPixleId: '1207702487503898',
    },
    mangonovel:{
        fbPixleId: '1166891804789310',
    },
    lycheenovel: {
        fbPixleId: '1617161705670956',
    },
    durianovel: {
        fbPixleId: '1174264804240795',
    },
    default: {
        fbPixleId: '1081737203961773',
        moneySymbol: '$',
    }
}
